// @ts-nocheck
/* eslint-disable */
import { store } from "~/state/store";
import { watch, watchCurrentUser } from "~/state/util";
import { OPTIONS } from "~/util/providers/mapybox";
import { CONFIG } from "~/config";
import Scene from "~/scene";
import { frpc } from "~/util/general";

const opts = { ...OPTIONS };
const limitOnPage = 50;
let base = null;
let rootIDS = {};
let folders = {};
let requests = {};

const w = watch(store.getState, "user", watchCurrentUser);
store.subscribe(w(() => {
	folders = {};
}));

Mapy.ProviderMapyBox = {};

// opts - { duplicity: "check|ignore" }
Mapy.ProviderMapyBox.likeCreate = (like = {}, hints = {}, opts = {}) => {
	let args = [like];

	if (opts && Object.keys(opts).length) {
		args.push(opts);
	}

	return _runRequest("like.create", args, hints, frpcData => {
		// update dat -> ulozeni like
		let parentID = like.parent_id || _getRealID("");

		Mapy.ProviderMapyBox.removeFolderFromCache(parentID);
		Mapy.getComponent("places").listRefreshData();
	});
}

// opts - { duplicity: "check|ignore" }
Mapy.ProviderMapyBox.createMulti = (likes = [], opts = {}) => {
	let args = [likes];

	if (opts && Object.keys(opts).length) {
		args.push(opts);
	}

	// nachystame hinty
	let hints = {};
	likes.forEach((i, ind) => {
		if (i.mark) {
			hints[`0.${ind}.mark.lon`] = "float";
			hints[`0.${ind}.mark.lat`] = "float";
		}
	});

	return _runRequest("all.createMulti", args, hints, frpcData => {
		// update dat -> ulozeni like
		if (likes.length) {
			let parentID = likes[0].parent_id || _getRealID("");

			Mapy.ProviderMapyBox.removeFolderFromCache(parentID);
			Mapy.getComponent("places").listRefreshData();
		}
	});
}

Mapy.ProviderMapyBox.likeUpdate = (id = "", like = {}, hints = {}) => {
	if (like.mark) {
		hints[`1.mark.lon`] = "float";
		hints[`1.mark.lat`] = "float";
	}

	return _runRequest("like.update", [id, like], hints, frpcData => {
		// update dat -> upravy jsonu
		let search = _search(id);

		search.items.forEach(i => {
			// update dat, polozku neposunujeme
			Object.assign(i.item, like);
			_update(search, like);
		});
	});
}

Mapy.ProviderMapyBox.likeDelete = (ids, opts = {}) => {
	ids = Array.isArray(ids) ? ids : [ids];

	let params = [ids];

	if (opts.folderId && opts.folderId !== "") {
		params.push(true);
		params.push(opts.folderId);
	}

	if (opts.type) {
		params.push(false);
		params.push("");
		params.push({
			type: opts.type,
		});
	}

	return _runRequest("like.delete", params, undefined, frpcData => {
		_delete(ids);
		let event = new CustomEvent("like.delete", { detail: { ids }});
		window.dispatchEvent(event);
	});
}

Mapy.ProviderMapyBox.likeMove = (ids, parentID = "0", opts) => {
	ids = Array.isArray(ids) ? ids : [ids];
	parentID = _getRealID(parentID);

	let params = [ids, parentID];

	if (opts?.actualFolderId && opts.actualFolderId != "") {
		params.push(true);
		params.push(opts.actualFolderId);
	}

	return _runRequest("like.move", params, undefined, frpcData => {
		// update dat -> presuneme idcka
		_likeMove(ids, parentID);

		// pro slozku parentID - v jejim rodici ji posuneme na prvni pozici
		let search = _search(parentID);

		search.items.forEach(i => {
			i.parent.folder.items.splice(i.ind, 1);
			i.parent.folder.items.unshift(i.item);
		});
	});
}

// pres hvezdicku, cizi k sobe do batuzku
Mapy.ProviderMapyBox.likeCopy = (ids, parentID = "0") => {
	ids = Array.isArray(ids) ? ids : [ids];
	parentID = _getRealID(parentID);

	return _runRequest("like.copy", [ids, parentID], undefined, frpcData => {
		// update dat -> prenacteni slozky kam se ulozila nova kopie
		Mapy.ProviderMapyBox.removeFolderFromCache(parentID);
	});
}

Mapy.ProviderMapyBox.likeDetail = id => {
	return _runRequest("like.detail", [id, { lang: CONFIG.langPriority }]);
}

/**
 * list polozek v moje mapy
 * @return {Promise} Promise
 */
Mapy.ProviderMapyBox.listLikes = () => {
	return _runRequest("listLikes", []);
}

/**
 * Odstraní složku z cache
 * @param {String} folderId
 */
Mapy.ProviderMapyBox.removeFolderFromCache = folderId => {
	if (!folderId) return;
	folderId = _getRealID(folderId);
	if (folderId in folders) {
		delete folders[folderId];
	}
}

/**
 * Odstraní všechny složky z cache
 */
Mapy.ProviderMapyBox.removeAllOtherFolderFromCache = folderId => {
	folderId = _getRealID(folderId);
	for (let fId in folders) {
		if (folderId != fId) {
			delete folders[fId];
		}
	}
}

Mapy.ProviderMapyBox.getHomeAndWork = () => {
	// vycisteni
	_cleanOldBase();

	if (base) {
		return base.promise;
	} else {
		return _runRequest("getBase", undefined, undefined, (frpcData, promise) => {
			let items = frpcData.items || [];
			let work = null;
			let home = null;
			const { user } = store.getState().user;

			items.forEach(item => {
				if (item.type == "work") {
					work = item;
				} else if (item.type == "home") {
					home = item;
				}
			});

			base = {
				data: {
					work,
					home
				},
				promise,
				time: Date.now(),
				email: user.accountDisplayName,
			};

			// zmenime def. promise resolve data
			return (base.data);
		});
	}
}

// @param {Object} [opts] Volitelna konfigurace
// @param {Boolean} [opts.route3d=false] Vratit data obohacena o data pro 3d zobrazeni
// @param {Boolean} [opts.skipCache=false] Preskocit kes
// @param {Boolean} [opts.limitOnPage=50] limit itemu na stranku
Mapy.ProviderMapyBox.folderList = (folderID = "0", coords, opts) => {
	folderID = _getRealID(folderID);
	let options = Object.assign({
		route3d: false,
		skipCache: false,
		limitOnPage: parseInt(Mapy.CUS?.mapybox?.limitOnPage || limitOnPage),
	}, opts);

	_cleanOld();

	const state = store.getState();
	const { user } = state.user;
	const { longitude, latitude } = state.map;
	let email = user.accountDisplayName;
	let folder = folders[folderID];

	if (folder && !options.skipCache) {
		return folder.promise;
	} else {
		coords = coords || Scene.coordsFromWGS84(longitude, latitude);

		let wgs84 = coords.toWGS84();
		let opts = {
			lon: wgs84[0],
			lat: wgs84[1],
			limit: parseInt(options.limitOnPage),
		};

		if (options.route3d) {
			opts["3d"] = true;
		}

		if (options.offset) {
			opts.offset = options.offset;
		}

		return _runRequest("folder.list", [folderID, opts], undefined, (frpcData, promise) => {
			// ulozime si data
			if (frpcData.folder) {
				let respID = frpcData.folder.id

				// rebind "0" na realne ID
				if ((folderID == "" || folderID == "0") && email) {
					rootIDS[email] = respID;
				}

				if (options.offset && folders[respID]) {
					if (folders[respID].data.folder?.items?.length && frpcData.folder?.items?.length) {
						folders[respID].data.folder.items = folders[respID].data.folder.items.concat(frpcData.folder.items);
					}
				}
				else {
					folders[respID] = {
						id: respID,
						time: Date.now(),
						promise,
						data: frpcData
					};
				}
			}
		});
	}
}

Mapy.ProviderMapyBox.getFolders = (folderID = "0", coords, limitOnPage) => {
	folderID = _getRealID(folderID);

	let promise = new JAK.Promise();

	if (folderID in folders) {
		promise.fulfill(_getFolders(folders[folderID].data));
	} else {
		Mapy.ProviderMapyBox.folderList(folderID, coords, {
			...limitOnPage ? { limitOnPage } : {}
		}).then(data => {
			promise.fulfill(_getFolders(data));
		}, e => {
			promise.reject(e);
		});
	}

	return promise;
}

Mapy.ProviderMapyBox.folderCopy = (id, parentID = "0", updateObj = {}) => {
	parentID = _getRealID(parentID);

	return _runRequest("folder.copy", [id, parentID, updateObj], undefined, frpcData => {
		// update dat -> prenacteni slozky kam se ulozila nova kopie
		Mapy.ProviderMapyBox.removeFolderFromCache(parentID);
	});
}

Mapy.ProviderMapyBox.folderTitle = (id) => {
	if (id in folders) {
		return folders[id].data.folder.title;
	}

	return "";
};

Mapy.ProviderMapyBox.folderUpdate = (id = "", folder = {}, hints = {}) => {
	return _runRequest("folder.update", [id, folder], hints, frpcData => {
		// update dat -> upravy jsonu
		let search = _search(id);

		search.rootFolders.forEach(i => {
			Object.assign(i.folder, folder);

			// propagace zmen pri zmenu publicu u slozky
			if ("public" in folder) {
				i.folder.items.forEach(foldItem => {
					foldItem.public = folder.public;
				});
			}
		});

		search.items.forEach(i => {
			Object.assign(i.item, folder);
		});
	});
}

Mapy.ProviderMapyBox.folderDelete = ids => {
	ids = Array.isArray(ids) ? ids : [ids];

	return _runRequest("folder.delete", [ids], undefined, frpcData => {
		// update dat -> smazeme idcka
		_delete(ids);
	});
}

Mapy.ProviderMapyBox.folderSort = (id, sortType = "custom", ids?) => {
	ids = Array.isArray(ids) ? ids : ids ? [ids] : [];

	return _runRequest("folder.sort", [id, sortType, ids], undefined, frpcData => {
		// update dat -> upravime poradi
		if (id in folders) {
			let item = folders[id].data;
			let itemsIDS = {};
			// ulozime si ID do objektu
			item.folder.items.forEach(i => {
				itemsIDS[i.id] = i;
			});
			// upravime serazene itemy podle pole ID
			item.folder.items = ids.map(sortedID => {
				return itemsIDS[sortedID];
			});
		}
	});
}

Mapy.ProviderMapyBox.folderCreate = (title, parentID = "") => {
	parentID = _getRealID(parentID);

	let createData = {
		title
	};

	if (parentID) {
		createData.parent_id = parentID;
	}

	return _runRequest("folder.create", [createData], undefined, frpcData => {
		// update dat -> vytvorime novy zaznam
		if (parentID in folders) {
			let time = Math.round(Date.now() / 1000);
			let data = folders[parentID].data;

			// na prvni pozici
			data.folder.items.unshift({
				update_time: time,
				title,
				items: [],
				public: false,
				foreign: false,
				parent_id: parentID,
				create_time: time,
				mark: {},
				type: "folder",
				id: frpcData.id
			});
			data.count = data.folder.items.length;
		}
	});
}

Mapy.ProviderMapyBox.trackDetail = (tid, route3d) => {
	// zvlast, nevraci se promise
	let args = [tid];

	if (route3d) {
		args.push({
			"3d": true
		});
	}

	return frpc({
		url: CONFIG.requestUrl + opts.url,
		method: "track.detail",
		args,
	});
}

Mapy.ProviderMapyBox.trackUpdate = (tid, data) => {
	return _runRequest("track.update", [tid, data], undefined, frpcData => {
		// update dat -> upravy jsonu
		let search = _search(tid);

		search.items.forEach(i => {
			Object.assign(i.item, data);
			if (data["data.info.trackType"]) {
				i.item.data.type = data["data.info.trackType"];
			}
		});
	});
}

Mapy.ProviderMapyBox.trackDelete = tid => {
	return _runRequest("track.delete", [tid], undefined, frpcData => {
		_delete([tid]);
	});
}

Mapy.ProviderMapyBox.trackList = opts => {
	return _runRequest("track.list", [opts]);
}

Mapy.ProviderMapyBox.trackSummary = (opts = {}) => {
	return _runRequest("track.summary", [opts]);
}

Mapy.ProviderMapyBox.trackLookup = (bbox, opts) => {
	return _runRequest("track.lookupbox", [bbox[0][0], bbox[0][1], bbox[1][0], bbox[1][1], opts], { "0": "float", "1": "float", "2": "float", "3": "float" });
}

/**
 * vytvoreni track linku
 * @param  {String} id        id tracku
 * @param  {String} parent_id id slozky
 * @param  {String} usertitle vlastni pojmenovani
 * @return {Promise}
 */
Mapy.ProviderMapyBox.trackLink = (id, parent_id = "", usertitle = "", description = "") => {
	let parentID = _getRealID(parent_id);
	let trackData = { id, parent_id };

	if (usertitle != "") {
		trackData.usertitle = usertitle;
	}

	if (description != "") {
		trackData.description = description;
	}

	return _runRequest("track.link", [trackData], undefined, frpcData => {
		if (parentID in folders) {
			delete folders[parentID];
		}
	});
}

// opts - { duplicity: "check|ignore" }
Mapy.ProviderMapyBox.trackCreate = (track, opts) => {
	let args = [track];

	if (opts && Object.keys(opts).length) {
		args.push(opts);
	}

	return _runRequest("track.create", args, undefined, frpcData => {
		// update dat -> ulozeni tracku
		let parentID = track.parent_id || _getRealID("");

		Mapy.ProviderMapyBox.removeFolderFromCache(parentID);
	});
}

/**
 * kopirovani tracku
 * @param  {String} id        id tracku
 * @param  {String} parent_id id slozky
 * @param  {String} usertitle vlastni pojmenovani
 * @return {Promise}
 */
Mapy.ProviderMapyBox.trackCopy = (id, parent_id = "", usertitle = "", description = "") => {
	let parentID = _getRealID(parent_id);
	let trackData = { id, parent_id };

	if (usertitle != "") {
		trackData.usertitle = usertitle;
	}

	if (description != "") {
		trackData.description = description;
	}

	return _runRequest("track.copy", [trackData], undefined, frpcData => {
		// update dat -> prenacteni slozky kam se ulozila nova kopie
		Mapy.ProviderMapyBox.removeFolderFromCache(parentID);
	});
}

Mapy.ProviderMapyBox.getRootId = () => {
	return _getRealID("0");
}

Mapy.ProviderMapyBox.lookup = (folderId = "0", bbox, zoom) => {
	let opts = {
		zoom: zoom || 17,
		//filterFrom: 200,
		folderId,
	}

	return _runRequest("folder.lookupbox", [bbox[0][0], bbox[0][1], bbox[1][0], bbox[1][1], opts], { "0": "float", "1": "float", "2": "float", "3": "float" });
}

Mapy.ProviderMapyBox.limitOnPage = parseInt(Mapy.CUS?.mapybox?.limitOnPage || limitOnPage);

/**
 * Odstraneni starych dat - po timeoutu.
 */
function _cleanOld() {
	let time = Date.now();

	Object.keys(folders).forEach(folderID => {
		let item = folders[folderID];

		if (item.time + opts.folderDuration < time) {
			Mapy.ProviderMapyBox.removeFolderFromCache(folderID);
		}
	});
}

function _cleanOldBase() {
	if (!base)
		return;

	const time = Date.now();
	const { user } = store.getState().user;
	const email = user.accountDisplayName;

	if ((base.time + opts.baseDuration) < time || base.email != email) {
		base = null;
	}
}

function _runRequest(method = "", args = [], hints = {}, dataCb) {
	if (!dataCb) {
		dataCb = () => {
		};
	}

	_cleanOld();

	let promise;
	let reqID = method + JSON.stringify(args);

	if (reqID in requests) {
		promise = requests[reqID].promise;
	} else {
		promise = new Promise((resolve, reject) => {
			let frpcRequest = frpc({
				url: CONFIG.requestUrl + opts.url,
				method,
				args,
				hints,
			}).promise.then(frpcData => {
				delete requests[reqID];

				// update dat - data i promise
				let cbOutput = dataCb(frpcData, promise, frpcRequest);

				resolve(cbOutput || frpcData);
			}, e => {
				delete requests[reqID];
				reject(e);
			});
		});

		requests[reqID] = {
			promise
		};
	}

	return promise;
}

function _search(ids) {
	ids = Array.isArray(ids) ? ids : [ids];

	let rootFolders = [];
	let items = [];

	ids.forEach(id => {
		if (id in folders) {
			rootFolders.push(folders[id].data);
		}

		Object.keys(folders).forEach(folderID => {
			let parentData = folders[folderID].data;
			parentData.folder.items.forEach((item, ind) => {
				if (item.id == id || (item.type == "link" && item.linktype == "track" && item.linkid == id)) {
					items.push({
						item,
						parent: parentData,
						parentID: folderID,
						ind
					});
				}
			});
		});
	});

	return {
		rootFolders,
		items
	};
}

function _delete(ids) {
	ids.forEach(id => {
		Mapy.ProviderMapyBox.removeFolderFromCache(id);

		Object.keys(folders).forEach(folderID => {
			let data = folders[folderID].data;
			data.folder.items = data.folder.items.filter(i => i.id != id);
			data.count = data.folder.items.length;
		});
	});
}

function _likeMove(ids, parentID) {
	let search = _search(ids);
	search.items.forEach(i => {
		// odebereme z puvodniho
		i.parent.folder.items = i.parent.folder.items.filter(i => ids.indexOf(i.id) == -1);
		i.parent.count = i.parent.folder.items.length;

		// vlozime do nove slozky
		if (parentID in folders) {
			let data = folders[parentID].data;
			data.folder.items.unshift(i.item);
			data.count = data.folder.items.length;
		}
	});
}

function _update(item, data) {
	let updateItem = item.items[0];
	if (updateItem.item.type == "link") { // kdyz se jedna o link, musime projit jinak a aktualizovat vsechny linky
		for (let folderId in folders) {
			let folder = folders[folderId];
			if (folder) {
				let items = folder.data.folder.items;

				for (let i = 0; i < items.length; i++) {
					if (items[i].type == "link" && items[i].linkid == updateItem.item.linkid) {
						Object.assign(items[i], data);
					}
				}
			}
		}
	}
	else {
		let folder = folders[updateItem.parentID]
		if (folder) {
			let items = folder.data.folder.items;

			for (let i = 0; i < items.length; i++) {
				if (items[i].id == updateItem.item.id) {
					Object.assign(items[i], data);
					break;
				}
			}
		}
	}
}

function _getFolders(data) {
	return (data.folder ? data.folder.items.filter(i => i.type == "folder") : []);
}

function _getRealID(id) {
	const { user } = store.getState().user;
	const email = user.accountDisplayName;

	// rebind prazdneho ID
	if ((id == "0" || id == "") && rootIDS[email]) {
		id = rootIDS[email];
	}

	return id;
}
